export default __webpack_public_path__ + "static/media/screen-4.b3693c29.jpg";